import { render } from "./HorizontalBarChart.vue?vue&type=template&id=3c72e369"
import script from "./HorizontalBarChart.vue?vue&type=script&lang=js"
export * from "./HorizontalBarChart.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/insights/chart-building/chart_templates/HorizontalBarChart.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3c72e369"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3c72e369', __exports__)) {
    api.reload('3c72e369', __exports__)
  }
  
  module.hot.accept("./HorizontalBarChart.vue?vue&type=template&id=3c72e369", () => {
    api.rerender('3c72e369', render)
  })

}


export default __exports__